"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgChartView = void 0;
const i18n_1 = require("../../exports/i18n");
const constants_1 = require("../../modules/shared/store/constants");
const selectors_1 = require("../../exports/store/selectors");
const datasheet_1 = require("../datasheet");
const views_1 = require("./views");
const config_1 = require("../../config");
const utils_1 = require("../../utils");
const field_types_1 = require("../../types/field_types");
const interface_1 = require("../../engine/ot/interface");
class OrgChartView extends views_1.View {
    get recordShowName() {
        return (0, i18n_1.t)(i18n_1.Strings.row);
    }
    get recordShowUnit() {
        return '';
    }
    static defaultStyle(snapshot, srcView) {
        // the first attachment field set as default cover field
        const initCoverField = srcView.columns.find(col => snapshot.meta.fieldMap[col.fieldId].type === field_types_1.FieldType.Attachment);
        const linkField = srcView.columns.find(col => {
            const field = snapshot.meta.fieldMap[col.fieldId];
            return field.type === field_types_1.FieldType.Link && field.property.foreignDatasheetId === snapshot.datasheetId;
        });
        return {
            isCoverFit: false,
            coverFieldId: initCoverField === null || initCoverField === void 0 ? void 0 : initCoverField.fieldId,
            isColNameVisible: true,
            linkFieldId: linkField === null || linkField === void 0 ? void 0 : linkField.fieldId,
            horizontal: false,
        };
    }
    static defaultColumns(srcView) {
        if (!srcView) {
            throw Error((0, i18n_1.t)(i18n_1.Strings.error_not_found_the_source_of_view));
        }
        const columns = srcView.columns.map((column, index) => {
            const fieldId = column.fieldId;
            if (index === 0) {
                return { fieldId };
            }
            return { fieldId, hiddenInOrgChart: true, hidden: true };
        });
        return columns;
    }
    static generateDefaultProperty(snapshot, activeViewId) {
        const views = snapshot.meta.views;
        let srcView;
        if (activeViewId) {
            srcView = (0, selectors_1.getViewById)(snapshot, activeViewId);
        }
        if (!srcView) {
            srcView = views[0];
        }
        return {
            id: datasheet_1.DatasheetActions.getNewViewId(views),
            name: datasheet_1.DatasheetActions.getDefaultViewName(views, constants_1.ViewType.OrgChart),
            type: constants_1.ViewType.OrgChart,
            columns: this.defaultColumns(srcView),
            rows: this.defaultRows(srcView),
            style: this.defaultStyle(snapshot, srcView),
            displayHiddenColumnWithinMirror: true
        };
    }
    static getViewIntroduce() {
        return {
            title: (0, i18n_1.t)(i18n_1.Strings.org_chart_view),
            desc: (0, i18n_1.t)(i18n_1.Strings.org_guide_desc),
            videoGuide: (0, utils_1.integrateCdnHost)(config_1.Settings.view_architecture_guide_video.value),
        };
    }
}
exports.OrgChartView = OrgChartView;
OrgChartView.setOrgChartStyle2Action = (snapshot, payload) => {
    const { viewId, styleKey, styleValue } = payload;
    const viewIndex = (0, selectors_1.getViewIndex)(snapshot, viewId);
    if (viewIndex < 0) {
        return null;
    }
    const view = snapshot.meta.views[viewIndex];
    if (view.type !== constants_1.ViewType.OrgChart || styleValue === view.style[styleKey]) {
        return null;
    }
    return {
        n: interface_1.OTActionName.ObjectReplace,
        p: ['meta', 'views', viewIndex, 'style', styleKey],
        oi: styleValue,
        od: view.style[styleKey],
    };
};
//# sourceMappingURL=org_chart_view.js.map